export enum PointsShapeType {
    Circle = 'circle',
    Diamond = 'diamond',
    Square = 'square',
    Triangle = 'triangle',
    TriangleDown = 'triangle-down',
}

export const POINT_SHAPES_IN_ORDER = ['circle', 'diamond', 'square', 'triangle', 'triangle-down'];
